import { Test } from "./AssessmentRelated/Test";
import { VisitTypes } from "./Enums";

export class Reports {
  id: number;
  testType: string;
  note: string;
  visitType: VisitTypes;
  therapistFirstname: string;
  therapistLastName: string;
  testName: string;
  time: string;
  score: Score;
  usedAssistiveDevice: number;
  startTime: Date;
  endTime: Date;
}

export interface Score {
  id: number;
}

export class GaitScore implements Score {
  id: number;
  fallRisk: number;
  gaitSpeed: number;
  distance: number;
  ambulationTime: number;
  velocity: number;
  meanNormalizedVelocity: number;
  numberOfSteps: number;
  cadence: number;
  left: {
    stepLength: number;
  };
  right: {
    stepLength: number;
  };
}

export class FiveXTSScore implements Score {
  id: number;
  skipped: boolean;
  mobility: string;
  repetitions: RepetitionStep[];
  overall: number;
}
export class UpperBodyAromScore implements Score {
  id: number;
  "Shoulder Abduction": { left: number; right: number; imgPath: any };
  "Shoulder Adduction": { left: number; right: number; imgPath: any };
  "Shoulder Flexion": { left: number; right: number; imgPath: any };
  "Shoulder Extension": { left: number; right: number; imgPath: any };
  "Elbow Flexion": { left: number; right: number; imgPath: any };
  "Elbow Extension": { left: number; right: number; imgPath: any };
  "Internal Rotation": { left: number; right: number; imgPath: any };
  "External Rotation": { left: number; right: number; imgPath: any };
}
export class RepetitionStep {
  index: number;
  time: number;
}

export class RLGLScore implements Score {
  id: number;
  averageSpeed: number;
  distance: number;
  redLightsMissed: number;
  metersLost: number;
}
export class AFScore implements Score {
  id: number;
  user1PlayedSeated: string;
  goodApples: number;
  badApples: number;
  goodApplePercentageCaught: number;
  badApplePercentageCaught: number;
  applesMissed: number;
  bestStreak: number;
  score: number;
  infiniteModeTimeLasted: number;
  totalLateralMovement: number;
  maxLateralStepLength: number;
  maxLateralStepLengthRight: number;
  maxLateralStepLengthLeft: number;
  maxLeanAngleLeft: number;
  maxLeanAngleRight: number;
  maxArmReachLeft: number;
  maxArmReachRight: number;
  averageArmOffsetPolled: string;
  bothArmDuration: number;
  leftArmOnlyDuration: number;
  rightArmOnlyDuration: number;
  difficulty: {
    movementType: string;
    movementDifficulty: string;
    gameTime: number;
  };
}
export class BalloonPopperScore implements Score {
  id: number;
  user1PlayedSeated: boolean;
  score: number;
  scorePerMinute: number;
  averageTimeToHit: string;
  totalBalloonsHit: number;
  balloonsHitPerMinute: number;
  totalBalloonsMissed: number;
  balloonsMissedPerMinute: number;
  averageTimeToHitTrend: any;
  settings: {
    time: number;
    reachDifficulty: string;
    reachDirection: string;
    armMode: string;
  };
  leftHand: {
    leftAcrossHit: number;
    leftAcrossMissed: number;
    leftAcrossAvgTimeToHit: number;
    leftAcrossReachDist: number;
    leftOutwardHit: number;
    leftOutwardMissed: number;
    leftOutwardAvgTimeToHit: number;
    leftOutwardReachDist: number;
  };
  rightHand: {
    rightAcrossHit: number;
    rightAcrossMissed: number;
    rightAcrossAvgTimeToHit: number;
    rightAcrossReachDist: number;
    rightOutwardHit: number;
    rightOutwardMissed: number;
    rightOutwardAvgTimeToHit: number;
    rightOutwardReachDist: number;
  };
}
export class VeggieSlicerScore implements Score {
  id: number;
  user1PlayedSeated: string;
  score: number;
  scorePerMinute: number;
  veggiesCut: number;
  veggiesMissed: number;
  spongesCut: number;
  veggieAccuracy: any;
  spongeAccuracy: number;
  right: {
    veggiesCut: number;
    spongesCut: number;
  };
  left: {
    veggiesCut: number;
    spongesCut: number;
  };
  difficulty: {
    time: number;
    vegetableMoveSpeed: string;
    reachDifficulty: string;
    armMode: string;
  };
}
export class TugScore implements Score {
  id: number;
  startTime: string;
  endTime: string;
  gait: {
    fallRisk: number;
    tugSpeed: number;
    distance: number;
    ambulationTime: number;
    velocity: number;
    meanNormalizedVelocity: number;
    numberOfSteps: number;
    cadence: number;
    usedAssistiveDevice: string;
  };
  timing: {
    totalTime: number;
  };
  result: string;
}
export class FunctionalReachScore implements Score {
  id: number;
  test_type: string;
  startTime: string;
  endTime: string;
  ForwardReach: number;
  RightReach: number;
  LeftReach: number;
  phases: {
    maximum_reach: number;
    maximum_reach_time: number;
    phase_score: number;
    mode: {
      index: number;
      code: string;
    };
  }[];
}

export class MctsibScore implements Score {
  id: number;
  test_type: string;
  startTime: string;
  endTime: string;
  SkeletonsCSV: string;
  ElapsedTime: number;
  CumulativeSwayDistance: number;
  MeanDisplacementFromStart: number;
  Sway_Range_x: number;
  Sway_Range_y: number;
  Sway_Range_z: number;
  PhaseScore: number;
  Mode: {
    Index: number;
    Code: string;
  };
  Visual: number;
  Somatosensory: number;
  Vestibular: number;
  Composite: number;
}
